<template>
  <div class='registration-page'>
    <div class='registration-page-container'>

      <div class='section'>
        <div class='section-header'>
          <h3>선택사항</h3>
        </div>
        <div class='section-body'>
            <dl class='field-group'>
                <dt class='field-label'>
                    <label for=' '>보안등급설정</label>
                </dt>
                <dd class="field-control">
                    <div class="field-control-sub">
                        <select v-model="retrieveData.prmsLine" name='check-line-limit' class='input-width-small'>
                            <option value="" >선택안함</option>
                            <option value="0">비제한</option>
                            <option value="2">2회선</option>
                            <option value="3">3회선</option>
                        </select>
                    </div>
                    <ul class="notice-text-list">
                        <li class='notice-text'>보안등급에 따라 온라인가입가능 회선수를 설정할 수 있습니다.</li>
                    </ul>
                </dd>
            </dl>
            <dl class='field-group'>
                <dt class='field-label'>
                    대리인 가입제한여부
                </dt>
                <dd class="field-control">
                    <div class="field-control-sub">

                        <div class='input-container input-horizontal'>
                            <input id='radio-04-01' v-model="retrieveData.agntEntrRstnYn" type="radio" name="agentEnter" value="Y" class='input-radio' title='대리인 가입제한여부 설정'>
                            <label for='radio-04-01' class='input-label'>제한</label>
                        </div>
                        <div class='input-container input-horizontal'>
                            <input id='radio-04-02' v-model="retrieveData.agntEntrRstnYn" type="radio" name="agentEnter" value="N" class='input-radio' title='대리인 가입제한여부 설정'>
                            <label for='radio-04-02' class='input-label'>비제한</label>
                        </div>

                    </div>
                    <ul class="notice-text-list">
                        <li class='notice-text'>본인이 아닌 대리인의 가입을 제한할 수 있습니다.</li>
                    </ul>
                </dd>
            </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ConnectedCarSecureOptionSection',
    props: {},
    data() {
      return {
        retrieveData: {
          prmsLine: '',
          agntEntrRstnYn: ''
        }
      }
    },
    computed: {},
    methods: {},
  }
</script>

<style scoped>
</style>
